// extracted by mini-css-extract-plugin
export default {"flashlight":"flashlight-module--flashlight--ee400","light":"flashlight-module--light--6595a","fadeIn":"flashlight-module--fadeIn--8930a"};